/**
 * @generated SignedSource<<20f66e06028069e451e0e20afe40a78b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTodoOverviewDisplayMode = "MEDIUM" | "MEDIUM_GROUPED";
export type WSTodoOverviewQuery$variables = {
  id: string;
};
export type WSTodoOverviewQuery$data = {
  readonly store: {
    readonly publicTeams: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverviewSettings_Store">;
  };
  readonly widgetTodoOverview: {
    readonly category: {
      readonly id: string;
    } | null;
    readonly displayMode: WidgetTodoOverviewDisplayMode;
    readonly id: string;
    readonly teams: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
};
export type WSTodoOverviewQuery = {
  response: WSTodoOverviewQuery$data;
  variables: WSTodoOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "WidgetTodoOverview",
  "kind": "LinkedField",
  "name": "widgetTodoOverview",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WSTodoOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WidgetTodoOverviewSettings_Store"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WSTodoOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "cacheID": "e9566f354bd8d9c02bdda8322f2bd866",
    "id": null,
    "metadata": {},
    "name": "WSTodoOverviewQuery",
    "operationKind": "query",
    "text": "query WSTodoOverviewQuery(\n  $id: ID!\n) {\n  store {\n    ...WidgetTodoOverviewSettings_Store\n    publicTeams {\n      id\n    }\n    id\n  }\n  widgetTodoOverview(id: $id) {\n    id\n    category {\n      id\n    }\n    displayMode\n    teams {\n      id\n    }\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n\nfragment TeamSelectListItem_Team on Team {\n  id\n  name\n  ...TeamIconCircleComponent_Team\n}\n\nfragment TeamSelectList_Team on Team {\n  id\n  name\n  isPrivate\n  ...TeamSelectListItem_Team\n}\n\nfragment WidgetTodoOverviewSettings_Store on Store {\n  publicTeams {\n    id\n    icon\n    name\n    color\n    isPrivate\n    ...TeamSelectList_Team\n  }\n}\n"
  }
};
})();

(node as any).hash = "2733f3fb7cfa1b088a11813adf14aecf";

export default node;
